import { savingsNudge, type Money, type PlainDate } from '@skoka/core';
import { incomeFacts, type AppState } from './store.js';

/** Напоминание относится к реальному приходу, а пропуск — к одной цели. */
export function goalCycle(state: AppState, goalId: string): { date: PlainDate; amount: Money; skipped: boolean } | null {
  const nudge = savingsNudge({ incomeFacts: incomeFacts(state.transactions), today: state.today,
    incomeStreams: state.incomeStreams, goals: state.goals });
  const ask = nudge.asks.find((a) => a.goalId === goalId);
  if (!nudge.cycleStart || !ask) return null;
  if (!ask.funded) return { date: nudge.cycleStart, amount: ask.amount, skipped: false };
  const events = (state.goalEvents ?? []).filter((e) => e.goalId === goalId && e.cycleStart === nudge.cycleStart);
  // После пропуска могли всё же отложить: тогда пропущенным взнос больше не называем.
  if (!events.some((e) => e.kind === 'skip') || events.some((e) => e.kind === 'contribution' && e.amount > 0)) return null;
  return { date: nudge.cycleStart, amount: ask.amount, skipped: true };
}
